<template>
   <div class="carouselItem">
       <component :is="widget.type" :widget="widget"/>
   </div>
</template>

<script>
import custom from '@/components/widgets/custom.vue';
import basicImage from '@/components/widgets/image.vue';
import schemeDocs from '@/components/widgets/schemeDocs.vue';
import news from '@/components/widgets/news.vue';
import ICIHomepage from '@/components/widgets/ICIHomepage.vue';
import NMRHomepage from '@/components/widgets/NMRHomepage.vue';

export default {
    name: 'carouselItem',
    components: { custom, schemeDocs, news, basicImage, ICIHomepage, NMRHomepage },
    props: {
        widget: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {

        };
    },
};
</script>

<style lang="scss" scoped>

</style>
